import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'clock_in', label: 'Clock In' },
  { key: 'clock_out', label: 'Clock Out' },
  { key: 'duration_hours', label: 'Hours', align: 'right' },
  { key: 'notes', label: 'Notes' },
];

export function AttendanceRegisterReport() {
  return (
    <ReportView
      title="Attendance Register"
      description="Clock in/out entries with computed duration."
      endpoint="/reports/hr/attendance"
      columns={COLUMNS}
      filters={['dateRange']}
    />
  );
}
